import React, { memo } from 'react'

import { func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import AiTermsNotice from '../AiTermsNotice/AiTermsNotice'
import FreeBetaCard from '../FreeBetaCard/FreeBetaCard'
import SubscriptionCard from '../SubscriptionCard/SubscriptionCard'

function EligibleForTrialBody({ onClose: handleClose }) {
  const t = useTranslation()

  return (
    <div className="usage-modal__eligible-for-trial">
      <p className="usage-modal__headline cgt-body-md">
        {t('usageModal.setupHeadline')}
      </p>

      <div className="usage-modal__cards">
        <FreeBetaCard onClose={handleClose} />
        <SubscriptionCard onClose={handleClose} />
      </div>

      <AiTermsNotice />
    </div>
  )
}

EligibleForTrialBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(EligibleForTrialBody)
